import { useEffect } from 'react';

const unsupportedEmojies = [
  ':melting_face:',
  ':face_with_open_eyes_and_hand_over_mouth:',
  ':face_with_peeking_eye:',
  ':saluting_face:',
  ':dotted_line_face:',
  ':face_with_diagonal_mouth:',
  ':face_holding_back_tears:',
  ':rightwards_hand:',
  ':leftwards_hand:',
  ':palm_down_hand:',
  ':palm_up_hand:',
  ':hand_with_index_finger_and_thumb_crossed:',
  ':index_pointing_at_the_viewer:',
  ':heart_hands:',
  ':biting_lip:',
  ':person_with_crown:',
  ':pregnant_man:',
  ':pregnant_person:',
  ':troll:',
  ':coral:',
  ':lotus:',
  ':bubbles:',
  ':empty_nest:',
  ':nest_with_eggs:',
  ':beans:',
  ':pouring_liquid:',
  ':jar:',
  ':playground_slide:',
  ':wheel:',
  ':ring_buoy:',
  ':crutch:',
  ':hamsa:',
  ':mirror_ball:',
  ':low_battery:',
  ':x_ray:',
  ':identification_card:',
];

export const handleDeleteUnsupportedEmojies = () => {
  unsupportedEmojies.forEach((emoji) => {
    const emojiElement = document.querySelector(`[title="${emoji}"]`);
    const parentEmojiElement = emojiElement?.parentNode?.parentNode;
    if (parentEmojiElement) {
      // @ts-ignore
      parentEmojiElement.remove();
    }
  });
};

const observer = new MutationObserver(handleDeleteUnsupportedEmojies);

export const useDeleteUnsupportedEmojies = (isEmojiSelectorOpen: boolean) => {
  useEffect(() => {
    if (isEmojiSelectorOpen) {
      const emojiSectionTitleElement = document.querySelector('.e16zneum');
      if (emojiSectionTitleElement) {
        observer.observe(emojiSectionTitleElement, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    } else {
      observer.disconnect();
    }

    return () => {
      observer.disconnect();
    };
  }, [isEmojiSelectorOpen]);

  return null;
};
